import { parse } from "date-fns";

type Mode = "light" | "dark";

// Canvas cannot read CSS custom properties, so the categorical series colors
// are inlined per mode. Slot order is fixed (never cycled) and was validated
// for colorblind-safe separation between adjacent stacked segments.
const SERIES_COLORS: Record<Mode, string[]> = {
  light: ["#2a78d6", "#eb6834", "#1baf7a", "#eda100", "#e87ba4", "#008300", "#4a3aa7", "#e34948"],
  dark: ["#3987e5", "#d95926", "#199e70", "#c98500", "#d55181", "#008300", "#9085e9", "#e66767"],
};

// Past the eighth cost type there is no distinct hue left; the rest share a neutral.
const OVERFLOW_COLOR: Record<Mode, string> = { light: "#8a8985", dark: "#6b6a66" };

export const costTypeColor = (slot: number, mode: Mode) =>
  SERIES_COLORS[mode][slot] ?? OVERFLOW_COLOR[mode];

export const CHART_GRID_COLOR: Record<Mode, string> = { light: "#e0e0e0", dark: "#333333" };

export const CHART_AXIS_TEXT_COLOR: Record<Mode, string> = { light: "#767676", dark: "#bdbdbd" };

// "2026-10" -> "Oct 2026"
export const formatMonth = (month: string) => {
  const parsed = parse(month, "yyyy-MM", new Date());
  return parsed.toLocaleDateString("en-US", { month: "short", year: "numeric" });
};
